export default {
    // API_BASE_URL: "http://localhost:4000/graphql",
    API_BASE_URL: "https://api-staging.dermaster.asia/graphql",
    LOGIN_WX_URL:
        "https://staff.workinfinityx.com/oauth?client_id=63febb807b3e425b6e49b64a",
    CUSTOMER_PAGE_URL: "https://c.dermaster.asia",
};
